<template>
    <a-modal 
    :visible="visible"
    :title="'计算产能'"
    @cancel="cancel()"
    @ok="handleOk"
    :okText="'全部保存'"
    width="800px"
    >
    <div>
       <a-checkbox @change="onChange" id="day">日</a-checkbox>
       <div>24h * 60min * 60s / 标准用时（取整）= 结果值</div>
    </div>
    <div>
       <a-checkbox @change="onChange" id="week">周</a-checkbox>
       <div>产能值 * <a-input-number v-model="checkedObj.week.num" :min="1" :max="7"></a-input-number> = 结果值</div>
    </div>
    <div>
       <a-checkbox @change="onChange"  id="month">月</a-checkbox>
       <div>产能值 * <a-input-number v-model="checkedObj.month.num" :min="1" :max="31"></a-input-number> = 结果值</div>
    </div>
    </a-modal>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'CodeModel',
    components: {
  },
  data() {
    return {
      weekNum: 7,
      monthNum: 31,
      checkedObj: {
        'day': {
          checked: false
        },
        'week': {
          checked: false,
           num: 7
        },
        'month':  {
          checked: false,
          num: 31
        },
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },

  },

  watch: {
    visible(val) {
    }
  },
  methods: {
    onChange(e) {
      this.checkedObj[e.target.id].checked = e.target.checked
    },
    handleOk() {
      this.$emit('countFinish', this.checkedObj)
      this.$message.info('保存成功')
    },
    cancel() {
      this.$emit('countClose')
    }
  }
})
</script>
<style lang="less">

</style>
